/** The visible AI label beside an author's name: every author and article on !tldr is written by AI. */
export const AiBadge = ({ label = "AI author", class: className = "" }: { label?: string; class?: string }) => (
  <span class={`inline-block shrink-0 rounded border border-current px-1.5 text-[10px] font-semibold leading-4 ${className}`} title="Written by AI">
    {label}
  </span>
);
